import React, { useState, useEffect } from 'react'
import { TopBar, TopBarSection, TextField } from '@duik/it'
import cls from '../styles/Header.scss'
import MainContainer from '../UI/MainContainer'
import LoadingContainer from '../UI/LoadingContainer'
import DashboardProjectsContainer from '../UI/DashboardProjectsContainer'
import SearchIcon from '@material-ui/icons/SearchOutlined'
import XIcon from '@material-ui/icons/CloseOutlined'
import ProjectCard from './ProjectDoughnuts/ProjectCard'
import Chart from 'chart.js'
import { api } from '../Controllers/api'

Chart.defaults.global.defaultFont = 'Roboto'

const Dashboard = props => {
  const [searchValue, setSearchValue] = useState('')
  const [projectDoughnuts, setProjectDoughnuts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get(`dashboard/projectDoughnuts`).then(({ data }) => {
      setProjectDoughnuts(data)
      setLoading(false)
    })
  }, []) //eslint-disable-line

  const search = e => {
    e.preventDefault()
  }

  const clearSearch = () => {
    setSearchValue('')
  }

  return (
    <MainContainer>
      {/* <div style={{ width: '100%' }}>
        <TopBar>
          <TopBarSection>
            <h2 className="uik-top-bar-title__wrapper" style={{ paddingLeft: '25px' }}>
              Dashboard
            </h2>
          </TopBarSection>
          <TopBarSection className={cls.actions}>
            <form className="dashboard-search-margin" onSubmit={e => search(e)}>
              <TextField
                placeholder="Search"
                rightEl={searchValue.length > 0 ? <XIcon onClick={clearSearch} /> : <SearchIcon />}
                onChange={e => setSearchValue(e.target.value)}
                value={searchValue}
                className="halfWidthInputBox"
                wrapperProps={{ style: { marginRight: '10px' } }}
              />
            </form>
          </TopBarSection>
        </TopBar>
      </div> */}
      {!loading ? (
        <DashboardProjectsContainer>
          {projectDoughnuts.map(({ projectNumber, projectName, chartInfo }) => (
            <ProjectCard
              key={projectNumber}
              history={props.history}
              projectNumber={projectNumber}
              projectName={projectName}
              chartInfo={chartInfo}
            />
          ))}
        </DashboardProjectsContainer>
      ) : (
        <LoadingContainer />
      )}
    </MainContainer>
  )
}

export default Dashboard
